<template>
    <div class="fullHeight">
        <div class="applist-header" :class="{'search-open': searchOpen}">
            <h4 class="font-8">
                Applications (<span class="list-items-count">{{itemsCount}}</span>)
            </h4>
            <AppListSearch
                :open.sync="searchOpen"
                :searchText.sync="searchText"
                :debounceTime="searchDebounceTime"
            />
        </div>
        <ul class="list customScroll" v-if="filteredList.length">
            <AppListItem
                v-for="item in filteredList"
                ref="appsListRef"
                :key="item.appKey"
                :id="item.appKey"
                :name="item.name"
                :platform="item.platform"
                :icon="item.icon"
                :hasAB="item.hasAB"
                :hasBiddingTest="item.hasBiddingTest"
                :hasQuickAB="item.hasQuickAB"
                :noNetworks="item.noNetworks"
                :active="isSelected(item)"
                @itemClicked="$emit('itemSelected', item)"
            />
        </ul>
        <div class="list no-results" v-else>
            <p class="font-6">No results found</p>
            <p class="font-7">Try different keywords</p>
        </div>
    </div>
</template>

<script>
import AppListSearch from './AppListSearch.vue';
import AppListItem from './AppListItem.vue';

export default {
    name: 'AppList',
    components: { AppListItem, AppListSearch },
    props: {
        listData: {
            type: Array,
            required: true
        },
        selectedApp: Object,
        searchDebounceTime: {
            type: Number,
            default: 0
        }
    },
    computed: {
        filteredList() {
            return this.listData.filter(({ name = '', appKey = '' }) => {
                const term = this.searchText.toLowerCase().trim();
                const includedInName = name.toLowerCase().includes(term);
                const includedInAppKey = appKey.toLowerCase().includes(term);

                return includedInName || includedInAppKey;
            });
        },
        itemsCount() {
            return this.listData ? this.listData.length : 0;
        }
    },
    data() {
        return {
            searchText: '',
            searchOpen: false
        };
    },
    methods: {
        isSelected(item) {
            return item === this.selectedApp;
        },
        scrollToApp(app) {
            const selectedIndex = this.listData.indexOf(app);
            const appComponent = this.$refs.appsListRef[selectedIndex];
            const appElement = appComponent.$refs.container;
            appElement?.scrollIntoView?.({ behavior: 'smooth' });
        }
    },
    mounted() {
        if (this.selectedApp) {
            this.scrollToApp(this.selectedApp);
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide.scss";

$headerHeight: 35px;

.applist-header {
    display: flex;
    position: relative;
    overflow: hidden;
    height: $headerHeight;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 0 15px;
    border-top: $border;
    border-right: $border;

    h4 {
        opacity: 1;
        transition: opacity 0.4s ease;
        color: $light-900;
        text-transform: uppercase;
        font-weight: normal;
        margin: 0;
    }

    &.search-open {
        h4 {
            opacity: 0;
        }
    }
}

.list {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    height: calc(100% - #{$headerHeight});
    border-top: $border;
    border-right: $border;
    margin: 0;
    padding-left: 20px;
    list-style: none;
}

.no-results {
    color: $light-700;
    padding-top: 36px;
    line-height: 22px;
    padding-left: 17px;

    p {
        margin: 0;
        text-align: center;
    }
}
</style>
